import { render, staticRenderFns } from "./EntregasIndex.vue?vue&type=template&id=fa8950a6"
import script from "./EntregasIndex.vue?vue&type=script&lang=js"
export * from "./EntregasIndex.vue?vue&type=script&lang=js"
import style0 from "./EntregasIndex.vue?vue&type=style&index=0&id=fa8950a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports